export var getEventPath = function getEventPath(event) {
  return event.path || event.composedPath && event.composedPath();
};